import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress, getSummaryReportId } from "./redux/selectors";
import SummaryReportEditorPanel from "./summaryReportEditorPanel";
const mapStateToProps = (state) => ({
    inProgress: getInProgress(state),
    data: getData(state),
    summaryReportId: getSummaryReportId(state)
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (summaryReportId) => dispatch(actionCreators.getSummaryReport(summaryReportId)),
    onClose: () => dispatch(actionCreators.setSummaryReportId(undefined))
});
export default connect(mapStateToProps, mapDispatchToProps)(SummaryReportEditorPanel);
